export enum EmailsEnum {
  SUPPORT = 'support@crm.vanliners.co.uk',
  SUPPORT_COM = 'support@crm.vanliners.com',
}
